import React from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "./Tooltip";
import { stringLengthLimiter } from "../utils/utils";

interface BreadcrumbItem {
  text: string;
  link?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2 text-gray-600">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.link ? (
            <button
              onClick={() => navigate(item.link!)}
              className="hover:text-blue-400 text-blue-600"
              onAuxClick={(e) => {
                e.preventDefault();
                window.open(item.link!, "_blank", "noopener,noreferrer");
              }}
            >
              <Tooltip content={item.text} display={item.text?.length > 12}>
                <>{stringLengthLimiter(item.text, 12)}</>
              </Tooltip>
            </button>
          ) : (
            <Tooltip content={item.text} display={item.text?.length > 12}>
              <span>{stringLengthLimiter(item.text, 12)}</span>
            </Tooltip>
          )}
          {index < items.length - 1 && <span>{">"}</span>}
        </React.Fragment>
      ))}
    </div>
  );
};
